import { Popup } from "devextreme-react";
import { useMemo } from "react";
import './ModalContainer.css';

export const ModalContainer = (props) =>{
    const { open, onClose, modalId, children, title, width = "60vw", height = "auto" } = props;

    // Generate a unique z-index that updates when modal opens to ensure proper stacking
    const zIndex = useMemo(() => 1500 + Math.floor(Math.random() * 100), [open, modalId]);

    const renderTitle = () => {
        return (
            <div className="modal-title-container">
                <div className="modal-title-text">
                    {title}
                </div>
                <div className="modal-close-button" onClick={onClose} title="Close">
                    <i className="dx-icon-close"></i>
                </div>
            </div>
        );
    };

    return (
        <Popup 
            key={`${modalId}-${open}`}
            id={modalId || "popup"}
            visible={open}
            onHiding={onClose}
            dragEnabled={true}
            resizeEnabled={true}
            showTitle={true}
            showCloseButton={false}
            titleRender={renderTitle}
            width={width}
            height={height}
            container="body"
            position="center"
            shading={true}
            shadingColor="rgba(0, 0, 0, 0.5)"
            closeOnOutsideClick={false}
            wrapperAttr={{ 
                style: { zIndex } 
            }}
        >
            {children}
        </Popup>
    );
}

export default ModalContainer;